import mutations from "./mutations";
import state from "./state";
import * as getters from "./getters";
import _cloneDeep from "lodash-es/cloneDeep";

export default {
  namespaced: true,
  state: _cloneDeep(state),
  mutations,
  getters
};
